// Auto-release slot bij browser/tab close.
// Gebruikt fetch met keepalive (betrouwbaarder dan sendBeacon voor JSON bodies).
import { getDeviceId } from "./device";

export function attachSlotAutoRelease(role) {
  // Admin claimt geen slot — sla over.
  if (!role || role === "admin") return () => {};

  const handler = () => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`;
      const body = JSON.stringify({ code: "", device_id: getDeviceId() });
      // keepalive: laat browser de request afmaken nadat de pagina dicht is.
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    } catch {
      // best effort
    }
  };

  window.addEventListener("pagehide", handler);
  window.addEventListener("beforeunload", handler);
  return () => {
    window.removeEventListener("pagehide", handler);
    window.removeEventListener("beforeunload", handler);
  };
}
